import { ref } from 'vue';

const config = useRuntimeConfig();
const isDemoModeEnabled = ref((config.public.ENVIRONMENT as string) !== 'prod');

export function useDemoMode() {
  const toggleDemoMode = () => {
    isDemoModeEnabled.value = !isDemoModeEnabled.value;
  };

  return {
    isDemoModeEnabled,
    toggleDemoMode,
  };
}
